(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lb-retailer-login/assets/javascripts/entry.js') >= 0) return;  svs.modules.push('/modules/lb-retailer-login/assets/javascripts/entry.js');

'use strict';

const ReactBrand = svs.ui.ReactBrand;
const _ReactRouterDOM = ReactRouterDOM,
  BrowserRouter = _ReactRouterDOM.BrowserRouter,
  Route = _ReactRouterDOM.Route;
const _svs$lb_retailer_logi = svs.lb_retailer_login,
  Login = _svs$lb_retailer_logi.Login,
  ChangePassword = _svs$lb_retailer_logi.ChangePassword;
const Entry = () => React.createElement(React.Fragment, null, React.createElement("div", {
  className: "bg-red-100 margin-bottom-2",
  style: {
    height: 88,
    boxShadow: '0 2px 2px 0 rgba(0, 0, 0, 0.25)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
}, React.createElement(ReactBrand, {
  brand: "svenskaspel-twolines",
  emblem: true,
  size: 500
})), React.createElement(BrowserRouter, {
  basename: svs.core.data.baseUrl
}, React.createElement(Route, {
  component: ChangePassword,
  path: "/byt-losenord"
}), React.createElement(Route, {
  component: Login,
  exact: true,
  path: "/"
})));
const container = document.querySelector('#react-root');
ReactDOM.render(React.createElement(Entry, null), container);

 })(window);